import { FORTA_BLACK, FORTA_ERROR } from '../../utils/colors';

/** Outlined `InputFields` border styles — default border uses FORTA_BLACK. */
export const OUTLINED_BORDER_SX = {
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: 1.5,
    borderColor: FORTA_BLACK,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: FORTA_BLACK,
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderWidth: 1,
    borderColor: FORTA_BLACK,
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: FORTA_BLACK,
  },
  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: FORTA_ERROR,
  },
  /** Flush to the left border of the input; MUI default indents helper to match the label notch. */
  '& .MuiFormHelperText-root': {
    marginTop: 0.1,
    marginInlineStart: 0,
    marginInlineEnd: 0,
    textAlign: 'start',
    width: '100%',
  },
};

/** Class hook so non-white surfaces can re-color the Required caption's border-masking fill (a border mask-cutout drifts off the line at some zoom levels). */
export const REQUIRED_INDICATOR_CLASS_NAME = 'FRequiredIndicator';
